import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllSubjectsRequest } from "../../../../modules/superadmin-modules/subjects/Actions";
import {
  createTeacherRequest,
  editTeacherRequest,
} from "../../../../modules/superadmin-modules/teachers/Actions";

const AddTeacher = ({ isAdd, data, setSelectedData }) => {
  const [selected, setSelected] = useState(data?.profile_picture ? "Current Image" : "");
  const openChapter = useSelector((state) => state.model.isOpen11);
  const subjects = useSelector((state) => state.superadminSubjects.subjects);
  const isLoading = useSelector((state) => state.chapters.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (data?.profile_picture) {
      setSelected("Current Image");
    } else {
      setSelected("");
    }
  }, [data]);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const departmentOptions = [
    { value: 0, label: "national" },
    { value: 1, label: "ig" },
    { value: 2, label: "american" },
    { value: 3, label: "college" },
  ];

  const defaultSubjects = data?.subjects?.map((val) => ({
    label: val?.name,
    value: val?.id,
  }));
  const defaultDepartment = departmentOptions.find(
    (option) => option.value == data?.department
  );
  console.log(openChapter);
  useEffect(() => {
    if (openChapter) {
      dispatch(getAllSubjectsRequest());
    }
  }, [openChapter]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة مدرس" : "تعديل  مدرس"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    if (isAdd) {
      let formData = await new FormData();
      for (let key in values) {
        if (key == "subject_id") {
          values?.subject_id?.map((val, idx) => {
            formData.append(`subjects[${idx}]`, val?.value);
          });
        } else formData.append(key, values[key]);
      }

      if (values.subject_id) {
        await dispatch(createTeacherRequest(formData, closeFunc));
      } else {
        toast.error("اختر المادة");
      }
    } else {
      let formData = await new FormData();
      formData.append("_method", "PUT");

      // Only include the fields we want to update
      const updateData = {
        name: values.name || data.name,
        bio: values.bio || data.bio,
        subject_id: values.subject_id || defaultSubjects,
        department:
          values.department !== undefined && values.department !== null
            ? values.department
            : data.department,
      };

      // Add profile picture if selected
      if (values.profile_picture) {
        updateData.profile_picture = values.profile_picture;
      }

      for (let key in updateData) {
        if (key == "subject_id") {
          updateData?.subject_id?.map((val, idx) => {
            formData.append(`subjects[${idx}]`, val?.value);
          });
        } else if (key == "profile_picture" && updateData[key]) {
          formData.append(key, updateData[key]);
        } else if (key !== "profile_picture") {
          formData.append(key, updateData[key]);
        }
      }

      dispatch(
        editTeacherRequest({
          id: data?.id,
          formData: formData,
          action: closeFunc,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم المدرس"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم المدرس"
              register={register}
              name="name"
            />
          </Box>
          <Box w="45%">
            <FormLabel>نبذة عن المدرس : </FormLabel>

            <Textarea
              defaultValues={data?.bio}
              error={errors?.bio?.message}
              {...register("bio")}
              name="bio"
            />
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>المادة : </FormLabel>
              <Select
                options={subjectsOptions}
                onChange={(data) => setValue("subject_id", data)}
                styles={colourStyles}
                isMulti
                placeholder="المادة"
                defaultValue={defaultSubjects}
              />
            </Box>
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>القسم : </FormLabel>
              <Select
                options={departmentOptions}
                onChange={(option) => setValue("department", option?.value)}
                styles={colourStyles}
                placeholder="القسم"
                defaultValue={defaultDepartment}
              />
            </Box>
          </Box>

          <Box w="45%">
            <FormLabel>رفع الصورة:</FormLabel>
            <Button
              bg="main_1"
              color="white"
              borderRadius="8px"
              textAlign="center"
              position="relative"
              w="100%"
            >
              <Text>{selected ? selected : "اختر ملف ليتم رفعه"} </Text>
              <Input
                onChange={(e) => {
                  setValue("profile_picture", e.target.files[0]);
                  setSelected((s) => e.target.files[0].name);
                }}
                type="file"
                placeholder="اختر ملف ليتم رفعه"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
              />
            </Button>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddTeacher;
